import { render, staticRenderFns } from "./virtualOrdersReports.vue?vue&type=template&id=28ea7502&"
import script from "./virtualOrdersReports.vue?vue&type=script&lang=js&"
export * from "./virtualOrdersReports.vue?vue&type=script&lang=js&"
import style0 from "./virtualOrdersReports.vue?vue&type=style&index=0&id=28ea7502&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports